import { render, staticRenderFns } from "./inventory-details.vue?vue&type=template&id=597b7cc0"
import script from "./inventory-details.vue?vue&type=script&lang=js"
export * from "./inventory-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports